import { API_VIDEO_PREFIX, SuiteApiClient } from "@weco/suite-client";

export const videoApi = new SuiteApiClient(API_VIDEO_PREFIX);
